// Update X search link for TwKeywordRequests#new
function setupTwKeywordRequestSearchLink() {
  const keywordSelect = document.getElementById('tw_keyword_request_keyword_id');
  const startDate = document.getElementById('tw_keyword_request_start_date');
  const endDate = document.getElementById('tw_keyword_request_end_date');
  const checkLink = document.getElementById('tw_keyword_request_check_link');

  if (!keywordSelect || !startDate || !endDate || !checkLink) return;

  function updateLink() {
    const kwText = keywordSelect.options[keywordSelect.selectedIndex]?.text || '';
    const from = startDate.value;
    const to = endDate.value;
    if (kwText && from && to) {
      const q = `${kwText} since:${from} until:${to}`;
      const url = `https://x.com/search?f=tweets&lang=ja&l=ja&q=${encodeURIComponent(q)}&src=typed_query`;
      checkLink.href = url;
      checkLink.textContent = `Xで検索（${kwText} / ${from}〜${to}）`;
    } else {
      checkLink.href = '#';
      checkLink.textContent = 'Xで検索（プレビュー）';
    }
  }

  updateLink();
  keywordSelect.addEventListener('change', updateLink);
  startDate.addEventListener('change', updateLink);
  endDate.addEventListener('change', updateLink);
}

document.addEventListener('turbo:load', setupTwKeywordRequestSearchLink);
